


const replace=(str)=>{
    if(str=="" || str==null)
    return str;
if(str.indexOf('+')!=-1){
    var reg=new RegExp('\\+','g');
    str= str.replace(reg, '%2B');
}
return str;
}



export {replace}